export const openSeaDragonDefaults = {
  initialZoom: 4,
  minZoom: 0.3,
  maxZoom: 12,
}

export const MAP_CIRCLE_CLASS_SELECTOR = '.map-circle'
export const FILTER_OUT_CLASSNAME = 'filter-out'
export const FILTER_OUT_CLASS_SELECTOR = '.filter-out'
